import React, { useState, useEffect } from 'react';
import Select from '../../../../components/Select';
import { useDispatch, useSelector } from 'react-redux';
import { FormHeader } from '../FormHeader';
import Button from '../../../../components/Button';
import { fetchServiceRequestStats } from 'src/store/actions/serviceRequestStats';
import Picker from '../../../../components/Picker';
import moment from 'moment';
import { IProperty } from 'src/pages/Reporting/ReportingFormTypes';
import useFetchServiceRequestStatsFormData from 'src/pages/Reporting/CustomHooks/useFetchServiceRequestStatsFormData';

interface ServiceRequestStatsProps {
  properties: IProperty[];
}

export const ServiceRequestStatsForm = ({
  properties,
}: ServiceRequestStatsProps) => {
  const dispatch = useDispatch();
  const auth = useSelector((state: any) => state.auth);

  const {
    assetTypeOptions,
    serviceRequestTagOptions,
    issueTypeOptions,
    serviceProviderOptions,
    loading,
    error,
    fetchData,
  } = useFetchServiceRequestStatsFormData();

  const [formData, setFormData] = useState({
    fromDate: undefined,
    toDate: new Date(),
    tags: undefined,
    issueType: undefined,
    serviceProvider: undefined,
    assetType: undefined,
    propertyId: undefined,
  });

  const handleInputChange = (val: any, key: any) => {
    setFormData((prev: any) => ({ ...prev, [key]: val }));
  };

  const generateData = () => {
    dispatch(
      fetchServiceRequestStats({
        from: formData.fromDate
          ? moment(formData.fromDate).format('YYYY-MM-DD')
          : undefined,
        to: moment(formData.toDate).format('YYYY-MM-DD'),
        tags: formData.tags,
        issueType: formData.issueType,
        serviceProvider: formData.serviceProvider,
        assetType: formData.assetType,
        propertyId: formData.propertyId,
      })
    );
  };

  useEffect(() => {
    const loadFormData = async () => {
      const loginUserId = auth.user.id;
      const role = auth.user.roles[0].role.name;
      await fetchData(loginUserId, role);
    };

    loadFormData();
  }, []);

  if (loading) {
    return <div>Loading form data...</div>;
  }

  if (error) {
    return <div>Error loading form data: {error}</div>;
  }

  return (
    <div>
      <h4>Select Report Dates</h4>
      <Picker
        label="From Date"
        placeholderText="Select Date"
        selected={formData.fromDate}
        onChange={(date: any) => handleInputChange(date, 'fromDate')}
        required={undefined}
      />
      <Picker
        label="To Date"
        placeholderText="Select Date"
        selected={formData.toDate}
        onChange={(date: any) => handleInputChange(date, 'toDate')}
        required={undefined}
      />
      <h4>Filter By:</h4>
      <FormHeader>Property</FormHeader>
      <Select
        placeholder="Select Property"
        options={
          properties?.map((property: any) => ({
            value: property.id,
            label: property.name,
          })) || []
        }
        value={formData.propertyId}
        onChange={(e: any) => handleInputChange(e.target.value, 'propertyId')}
      />
      <FormHeader>Issue Type</FormHeader>
      <Select
        placeholder="Select Issue Type"
        options={issueTypeOptions}
        value={formData.issueType}
        onChange={(e: any) => handleInputChange(e.target.value, 'issueType')}
      />
      <FormHeader>Asset Type</FormHeader>
      <Select
        placeholder="Select Asset Type"
        options={assetTypeOptions}
        value={formData.assetType}
        onChange={(e: any) => handleInputChange(e.target.value, 'assetType')}
      />
      <FormHeader>Service Provider</FormHeader>
      <Select
        placeholder="Select Service Provider"
        options={serviceProviderOptions}
        value={formData.serviceProvider}
        onChange={(e: any) =>
          handleInputChange(e.target.value, 'serviceProvider')
        }
      />
      <FormHeader>Tag</FormHeader>
      <Select
        placeholder="Select Tag"
        options={serviceRequestTagOptions}
        value={formData.tags}
        onChange={(e: any) => handleInputChange(e.target.value, 'tags')}
      />
      <Button
        color="teal"
        size="small"
        label="Generate Report"
        onClick={generateData}
      />
    </div>
  );
};
